<template>
  <div>
    <page-title :title="pageTitle">
      <template v-slot:bottom>
        <tabs :tabs="tabs" />
      </template>
    </page-title>

    <div class="my-esims-wrapper">
      <nuxt-child />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'my-esims',
    components: {
      PageTitle: () => import('~/components/shared/page-title.vue'),
      Tabs: () => import('~/components/tabs/route-switcher-tabs.vue'),
    },

    data() {
      return {
        pageTitle: this.$t('components.tabbar.my-esims'),

        tabs: [
          {
            text: this.$t('scenes.my.esims.current-tab'),
            type: 'local',
            route: {
              name: 'my-esims-index',
            },
          },
          {
            text: this.$t('scenes.my.esims.archived-tab'),
            type: 'regional',
            route: {
              name: 'my-esims-index-archived',
            },
          },
        ],
      }
    },

    scrollToTop: true,
  }
</script>

<style lang="scss" scoped>
  .my-esims-wrapper {
    border-top: 1px solid #ddd;

    @media only screen and (max-width: 767px) {
      border-top: none;
    }
  }
</style>
